/* eslint-disable @typescript-eslint/no-explicit-any */
// Exchange Control (iTraceabilities) contra el GraphQL de masterws. Usa variables, no texto pegado en la query.
import * as url from './url_helper';

const gql = async (query: string, variables: any = {}) => {
  const r = await fetch(url.API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  }).then((x) => x.json());
  if (r?.errors?.length) throw new Error(r.errors[0].message);
  return r?.data || {};
};

// El backend combina filtros con este separador de condición (Magaya/Constants: conditionSeparator + 'and').
const Y = '%%$_and';

const usuario = () => {
  try {
    return JSON.parse(localStorage.getItem('authUser') || '{}');
  } catch (e) {
    return {};
  }
};
export const esAdminHub = () => String(usuario().ROL_ID) === '19';
// Quien no es admin solo ve lo de su empresa, igual que el Exchange Control viejo.
const clienteFijo = () => (esAdminHub() ? '' : String(usuario().EMPRESA_ID ?? ''));

const armar = (filters: any, order?: string) => {
  const f: any = { initial_date: filters.from || null, final_date: filters.to || null, light: true };
  if (order) f.order = order;
  if (filters.search) f.search = filters.search;
  if (filters.level) f.logLevel = filters.level;
  if (filters.operation) f.Operation = `${filters.operation}${Y}`;
  if (filters.taskId) f.taskId = `${filters.taskId}${Y}`;
  const cliente = clienteFijo() || filters.clientId;
  if (cliente) f.ClientId = `${cliente}${Y}`;
  return f;
};

const LISTA = `query ($filters: GetTraceabilityFiltersInput, $p: PaginationInput!) {
  GetTraceabilityByWrNumber(filters: $filters, Pagination: $p) {
    CountItems
    listData { id Number Operation taskId ClientId user text1 text2 text5 WRNUMBER logLevel createdAt iTask { descripcion } }
  }
}`;

export const getExchange = async ({ pagination, filters, order }: any) => {
  const data = await gql(LISTA, {
    filters: armar(filters, order),
    p: { sizePage: pagination.sizePerPage, actualPage: pagination.page },
  });
  return data.GetTraceabilityByWrNumber || { listData: [], CountItems: 0 };
};

export const countExchange = async (filters: any) => {
  const data = await gql(LISTA, { filters: armar(filters), p: { sizePage: 1, actualPage: 1 } });
  return data.GetTraceabilityByWrNumber?.CountItems || 0;
};

export const getExchangeDetail = async (id: number) => {
  const data = await gql(
    `query ($id: Int!, $c: String) {
      GetTraceabilityById(id: $id, ClientId: $c) {
        id Number Operation taskId ClientId dateOfi timeOfi user text1 text2 text3 text4 text5 WRNUMBER logLevel createdAt iTask { descripcion }
      }
    }`,
    { id, c: clienteFijo() || null },
  );
  return data.GetTraceabilityById || null;
};

export const getExchangeOptions = async ({ from, to, clientId }: any) => {
  const data = await gql(
    `query ($filters: GetTraceabilityFiltersInput) {
      GetExchangeFilterOptions(filters: $filters) { operations tasks { id name } clients { id name } }
    }`,
    { filters: { initial_date: from || null, final_date: to || null, ClientId: clienteFijo() || clientId || null } },
  );
  return data.GetExchangeFilterOptions || { operations: [], tasks: [], clients: [] };
};
